import type React from 'react';
import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';
import { PageLoading } from '@/app/components/page-loading.tsx';

const LazySettings = lazy(() => import('./Settings'));

const Settings = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode }) => (
  <Suspense fallback={<PageLoading />}>
    <LazySettings {...props} />
  </Suspense>
);

export const settingsRoute = {
  path: '/settings',
  element: <Settings />,
} as RouteObject;

export default Settings;
